const CHOISIR_STATUT_COMPTE_METIER_ASSO = 'CHOISIR_STATUT_COMPTE_METIER_ASSO';

export const choisirStatutCompteMetierAsso = (statut) => (dispatch) => {
    dispatch({
        type: CHOISIR_STATUT_COMPTE_METIER_ASSO,
        payload: statut,
    });
};

// eslint-disable-next-line default-param-last
export const creerCompteReducer = (state = null, action) => {
    switch (action.type) {
        case CHOISIR_STATUT_COMPTE_METIER_ASSO:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
